import { UserProfile } from "Domain/User/Entity/UserProfile";

export type PaymentOutStatus = "INIT" | "PENDING" | "TO_PAY" | "PAYED";

export type PaymentOutCondition =
  | "SECURED_CONDITION"
  | "FINAL_SECURED_CONDITION";

export type PaymentInStatus =
  | "INIT"
  | "AUTHORIZED"
  | "PARTIALLY_COLLECTED"
  | "OVERPAID"
  | "COLLECTED"
  | "UNPAID";

export type PaymentPlanStatus =
  | "INIT"
  | "PENDING"
  | "FINISHED"
  | "APPROVED"
  | "VALID"
  | "DECLINED"
  | "INVALID"
  | "CANCELED"
  | "PARTIALLY_VALID";

export type PaymentIn = {
  sequence: number;
  dueDate: string;
  paymentAmount: string;
  receivedAmount: string;
  dueAmount: string;
  status: PaymentInStatus;
};

export type PaymentOut = {
  sequence: number;
  date: string;
  paymentAmount: number;

  fees: number;
  vat: number;
  toPayAmount: number;
  toPayCondition?: PaymentOutCondition;

  status: PaymentOutStatus;
  paymentPlanPublicId: string;
  sessionLimitDate?: string;
};

export type PaymentPlan = {
  financedAmount: number;
  dueAmount: number;
  createdDate: number;
  status: PaymentPlanStatus;
  secured: boolean;

  numberOfSessions: number;
  debtorProfile: UserProfile;
  debtorId: string;
  quote: string;

  paymentServiceIdentifier: string;

  publicId: string;
  createdAt: string;
  updatedAt: string;

  creditorId: string;
  contractSigned: boolean;

  paymentsIn: Array<PaymentIn>;
  paymentsOut?: Array<PaymentOut>;
  creditorData: {
    publicId: string;
    name: string;
  };
};

export class PaymentPlanEntity {
  paymentPlanData: PaymentPlan;

  constructor(paymentPlanData: PaymentPlan) {
    this.paymentPlanData = paymentPlanData;
  }

  isContractSigned() {
    return this.paymentPlanData.contractSigned;
  }

  isPaymentProcessStarted() {
    return !["PENDING", "INIT"].includes(this.paymentPlanData.status);
  }

  getNextSecuredPayout() {
    let paymentOut: PaymentOut | null = null;
    if (
      this.paymentPlanData.secured &&
      this.isPaymentProcessStarted() &&
      this.paymentPlanData.paymentsOut
    ) {
      const foundPayouts = this.paymentPlanData.paymentsOut.find(
        (payout: PaymentOut) =>
          payout.sequence <= this.paymentPlanData.numberOfSessions &&
          payout.toPayCondition
      );
      paymentOut = foundPayouts ? foundPayouts : null;
    }

    return paymentOut;
  }
}
